
<template>
   <basic-container>
       <el-form :inline="true" :model="selectForm" status-icon ref="ruleForm" label-width="150px" class="only-one-1">
           <el-row :gutter="24">
             <el-col :span="6">
              <el-form-item label="申报单位" prop="pass">
                <el-select v-model="selectForm.projectId" placeholder="请选择">
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    >
                  </el-option>
                </el-select>   
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="周期" prop="checkPass">
                  <el-date-picker
                    v-model="selectForm.period"
                    type="year"
                    value-format="yyyy"
                    placeholder="选择年">
                  </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="float:right">
                              <el-button type="primary" icon="el-icon-search"  @click="valueBudgetSearch" size="small"> 搜索 </el-button>
                              <el-button icon="el-icon-delete" @click="searchReset" size="small"> 清空 </el-button>
              </div>
            </el-col>
           </el-row>
        </el-form>
         <avue-crud :option="option"
                   :table-loading="loading"
                   :data="valueBudgetList"
                   :page.sync="page"
                   v-model="selectForm"
                   ref="crud"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
          <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addValueDeclare"> 新 增</el-button>
            
            </template>
        <template slot-scope="scope" slot="menu">
          <el-button
          type="text"
          size="small"
          icon="el-icon-printer"
          v-if=" scope.row.feeSortCount !== ''"
          @click="valueBudgetPreview(scope.row.id)"
          >详情
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-printer"
          v-if="scope.row.releaseStatus==1||scope.row.releaseStatus==4"
          @click="valueBudgetEdit(scope.row.id)"
          >编辑
        </el-button>
        
      </template>
        </avue-crud>
        <el-dialog
            v-if="dialogVisible"
            title=""
            :visible.sync="dialogVisible"
            width="90%"
            append-to-body
            :before-close="declareClose" 
            >
           <valueDeclare  @preview='valueBudgetPreview' :editDetailInfo='editDetailInfo' />
        </el-dialog>
   </basic-container>
</template>

<script>
import dayjs from 'dayjs';
import urlSettings from '@/config/url-settings.js';
import { getProjectList } from '@/api/crmedical/project/project';
import {
  getUserInfo,
  getPreviewInfo,
  getList,
  getEditDetail,
  getContentName,
} from '@/api/crmedical/value/valuebudget';
import valueDeclare from './valueDeclare';
import { mapGetters } from 'vuex';
export default {
  components: { valueDeclare },
  data() {
    return {
      selectForm: {
        projectId: '',
        period: '',
      },
      projectList: [],
      loading: false,
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
      dialogVisible: false,
      ruleForm: {
        pass: '',
        checkPass: '',
        age: '',
      },
      valueBudgetList: [],
      option: {
        index: true,
        page: true,
        align: 'center',
        menuAlign: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border:true,
        column: [
          {
            label: '申报单位',
            prop: 'projectName',
           
          },
          {
            label: '申报人',
            prop: 'submitName',
            
          },
          {
            label: '联系方式',
            prop: 'submitMobile',
          },
          {
            label: '周期',
            prop: 'cycle',
          },
          {
            label: '申报日期',
            prop: 'declareTime',
          },
          {
            label: '状态',
            prop: 'releaseStatus',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=value_release_status',
          },
        ],
      },
      editDetailInfo: {},
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.initData();
    
  },
  methods: {
    //详情（预览）
    async valueBudgetPreview(id) {
      console.log('查看');
      let path = ''; //urlSettings.VUE_APP_BASE_REPORT_URL + urlSettings.VUE_APP_ENVIRONMENT + '/fastNewbill.cpt&op=write&payBillNo='+111111;
      await getPreviewInfo(id).then(({ data }) => {
        let additionalDescription = this.editorImg(data.additionalDescription);
        //  console.log(additionalDescription)
        //  console.log(additionalDescription)
        let checkDescription = this.editorImg(data.checkDescription);
        let deptDescription = this.editorImg(data.deptDescription);
        //  path='http://localhost:8075/webroot/decision/view/report?viewlet=valueDeclarePreview.cpt'+
        // path = ' http://rpt-test.pms1.cn/webroot/decision/view/form?viewlet='+`/valueDeclarePreview.cpt` +

        // path='http://localhost:8075/webroot/decision/view/report?viewlet=hpss_test/eg.cpt'+
        path =
          urlSettings.VUE_APP_BASE_REPORT_URL +
          urlSettings.VUE_APP_ENVIRONMENT +
          `/valueDeclarePreview.cpt` +
          `&deptName=${data.projectName}&submitName=${data.submitName}&submitMobile=${
            data.submitMobile
          }` +
          `&submitEmail=${data.submitEmail}&createTime=${dayjs(data.createTime).format(
            'YYYY-MM-DD'
          )}&periodStart=${data.periodStart}&periodEnd=${data.periodEnd}&id=${id}` +
          `&deptDescription=${deptDescription}&clinicalEvaluationBase=${
            data.clinicalEvaluationBase
          }&clinicalEvaluationThreshold=${data.clinicalEvaluationThreshold}` +
          `&patientSatisfactionBase=${data.patientSatisfactionBase}&patientSatisfactionThreshold=${
            data.patientSatisfactionThreshold
          }` +
          `&sharingCoefficient=${
            data.sharingCoefficient
          }&checkDescription=${checkDescription}&additionalDescription=${additionalDescription}`;
      });
      await getContentName(id).then((data) => {
        let arry = data.data;
        for (let i = 0; i < arry.length; i++) {
          path += `&content${i + 1}=${arry[i]}`;
        }
      });
      window.open(
        path,
        'newindow',
        'height=600,width=1100,top=100,left=100,toolbar=no,' +
          'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
      );
    },
    //  操作富文本里的img
    editorImg(contents) {
      // contents = contents.replace(/"/g,"'");
      let r = RegExp(/<[img]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      let matchres = contents.match(r); //返回数组['<img ... />','<img ... />']
      console.log('matchres===', matchres);
      if (matchres) {
        matchres.forEach((item) => {
          let len = item.length;
          let _str = item.slice(0, len - 1) + ' style="width:200px"/>'; //追加之后的img
          contents = contents.replace(item, _str);
        });
      }
      return contents;
    },
    addValueDeclare() {
      if (this.selectForm.projectId) {
        getUserInfo(this.userInfo.user_id).then(({ data }) => {
          this.dialogVisible = true;
          let projectName;
          this.projectList.forEach((item) => {
            if (item.id == this.selectForm.projectId) {
              projectName = item.name;
            }
          });
          this.editDetailInfo = {
            id: '',
            projectId: this.selectForm.projectId,
            projectName: projectName,
            submitName: this.userInfo.nick_name,
            submitMobile: data.phone,
            submitEmail: data.email,
          };
        });
      } else {
        this.$confirm('还没有选择部门,请选择')
      }
    },
    declareClose() {
      this.editDetailInfo = {
        id: '',
      };
      this.onLoad();
      this.dialogVisible = false;
    },
    searchReset() {
      this.selectForm.period= ''
      this.onLoad();
    },
    valueBudgetSearch() {
      this.page.currentPage = 1
      this.onLoad();
    },
    initData() {
      //获取部门
      getProjectList().then((data) => {
        this.projectList = data.data;
        //默认选择第一个
        this.selectForm.projectId = this.projectList[0].id;
        this.onLoad();
      });
    },
    async valueBudgetEdit(id) {
      //获取接口数据
      await getEditDetail({ id: id }).then((data) => {
        this.editDetailInfo = data.data;
        this.editDetailInfo.id = id;
        console.log('接口', this.editDetailInfo);
        this.dialogVisible = true;
      });

      //传送到dialog
    },
    async getValueList() {
      const { data } = await getList();
      this.valueBudgetList = data.records;
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if(this.selectForm.projectId){
        getList(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.selectForm)
      ).then(({ data }) => {
        this.page.total = data.total;
        this.valueBudgetList = data.records;
        this.loading = false;
        console.log('page', this.page);
      });
      }else{
        this.initData()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .only-one-1 .el-form-item{
  display: flex;
}
</style>
